var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ad"},[_c('a',{attrs:{"href":'https://www.wch.cn/products/' +
        _vm.post.alias +
        '.html?from=signature_ad'}},[_vm._v("热门产品 : "+_vm._s(_vm.post.shortTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }